import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { getAssetFileUrlList } from '~/api';
import useToast from '~/store/useToast';

const useGetAssetFileUrlListMutation = () => {
  const { showToast } = useToast();

  return useMutation({
    mutationFn: getAssetFileUrlList,
    onError: (error) => {
      console.error(error);
      showToast('error', 'failed fetch');
    },
  });
};

export default useGetAssetFileUrlListMutation;
